import { ValidationResult, ValidationSeverity } from './validateSchema';

/**
 * Standard interface for tracking validation counts by severity
 */
export interface ValidationCounts {
  errors: number;
  warnings: number;
  total: number;
}

/**
 * Summary result with additional count information
 */
export interface ValidationSummary {
  result: ValidationResult;
  counts: ValidationCounts;
}

/**
 * Create a validation summary from counts of errors and warnings.
 *
 * @param counts - The counts of errors and warnings.
 * @returns A ValidationResult object summarizing the validation status.
 */
export const createValidationSummary = (
  counts: ValidationCounts
): ValidationResult => {
  const messages = [];

  if (counts.errors > 0) {
    messages.push({
      path: 'summary',
      message: `${counts.errors} validation error${
        counts.errors !== 1 ? 's' : ''
      } found`,
      severity: 'error' as ValidationSeverity,
    });
  }

  if (counts.warnings > 0) {
    messages.push({
      path: 'summary',
      message: `${counts.warnings} warning${
        counts.warnings !== 1 ? 's' : ''
      } found`,
      severity: 'warning' as ValidationSeverity,
    });
  }

  return {
    valid: counts.errors === 0,
    messages,
  };
};
